// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import Native from './utils/Native'
import util from './utils/util'
import dialog from './components/dialog'
import imgPreview from './components/imgPreview'
import FastClick from 'fastclick'
import 'babel-polyfill'
import promise from 'es6-promise'
promise.polyfill()

Vue.use(dialog)
Vue.use(imgPreview)

FastClick.attach(document.body);

Vue.filter('dateFormat', (val, fmt) => {
    return util.dateFormat(val, fmt);
})

window.$store = store;

Vue.config.productionTip = false

Vue.prototype.$Native = Native;
window.gonewpage = function(url) {
    Native.gonewpage(url)
};

/* eslint-disable no-new */
window.$vue = new Vue({
    el: '#app',
    store,
    router,
    components: { App },
    template: '<App />'
})



// WEBPACK FOOTER //
// ./src/main.js